function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "8",
  height: "200",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M.259 118.158l.502-2.984 1.164-2.141 4.638-5.73 1.176-1.865-.206-1.683-5.616-7.102L.703 93.95l-.49-2.092-.311-3.3.089 31.156z",
  fill: "#f5f5f5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.997 575.663v-953.332l-7.763-.053-.04 469.58.491 2.091 1.217 2.704 4.058 5.037 1.576 2.065.207 1.683-1.18 1.866-4.652 5.729-1.168 2.141-.504 2.984-.006 457.5",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M.279-375.946V90.847c0 2.312.624 4.646 2.083 6.44l4.747 5.84c.816 1.003.813 2.506 0 3.512l-4.747 5.881c-1.453 1.8-2.083 4.129-2.083 6.441v456.984",
  stroke: "#979797",
  strokeWidth: ".5",
  fill: "none"
})));